import { createApp } from 'vue'
import VueWechatTitle from 'vue-wechat-title'
import App from './App.vue'
import router from './router'
import { getProjectType, getDeviceType, resetKeyboard } from '@/assets/js/common'
import { messages, message } from './assets/js/message' // 引入消息相关的配置和方法
import './assets/js/rem'
import 'vant/lib/index.css'

const app = createApp(App)
app.use(VueWechatTitle)
app.config.globalProperties.productionTip = false
app.use(router)

// 使用 provide 提供消息数组
app.provide('messages', messages)

// 将 message 对象暴露给全局
app.config.globalProperties.$message = message

const projectType = getProjectType()

// 添加导航守卫
if (projectType === 'support') {
  router.beforeEach((to, from, next) => {
    const currentDevice = getDeviceType()
    const system = to.params.system
    const path = to.path

    // 检查路径中的设备类型
    const urlEquip = path.match(`/${system}/(.*)/(.*)`)
    if (urlEquip !== null && urlEquip.length > 2) {
      const pathDevice = urlEquip[1]
      if (['pc', 'mobile'].includes(pathDevice) && currentDevice !== pathDevice) {
        let sNewUrl = `/${system}/${currentDevice}/`
        if (urlEquip[2]) {
          sNewUrl += urlEquip[2]
        }
        if (to.query) {
          sNewUrl += `?${new URLSearchParams(to.query).toString()}`
        }
        return next(sNewUrl)
      }
    }
    next()
  })
}

if (['development'].indexOf(import.meta.env.VITE_NODE_ENV) >= 0 && projectType === 'risk') {
  import('vconsole').then((VConsoleModule) => {
    const VConsole = VConsoleModule.default
    const vConsole = new VConsole()
    app.use(vConsole)
  })
}

app.mount('#app')
/**
 * 处理iOS 微信客户端6.7.4 键盘收起页面未下移bug
 */
resetKeyboard()
